import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ConfigService } from "@core/config/app.config.service";
import { LoggerService } from "@shared/services/apl-afiliacion/logs/logger.service";
// TEMPORAL_RESPALDO_CARGA_MASIVA: retirar este import al desactivar el respaldo.
import { ES_RESPALDO_CARGA_MASIVA } from "@shared/services/afiliacion/respaldo-carga-masiva.context";
import { Observable, throwError, TimeoutError } from "rxjs";
import { catchError, map, timeout } from "rxjs/operators";
const APP_XHR_TIMEOUT = 50000;

@Injectable()
export class DefaultInterceptor implements HttpInterceptor {


  constructor(
    private readonly injector: Injector,
    private readonly configService: ConfigService,
    
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const logger = this.injector.get(LoggerService);
    const started = Date.now();
    const request = this.performRequest(req);

    // INICIO TEMPORAL_RESPALDO_CARGA_MASIVA: excepción HTTP exclusiva del respaldo.
    if (request.context.get(ES_RESPALDO_CARGA_MASIVA)) {
      // The standalone backup returns the gateway's data envelope, and must finish
      // before the original upload calls start. Keep other requests unchanged.
      return next.handle(request).pipe(timeout(300000));
    }
    // FIN TEMPORAL_RESPALDO_CARGA_MASIVA

    return next.handle(request).pipe(
      timeout(APP_XHR_TIMEOUT),
      map((res) =>
        this.handleSuccessfulResponse(res, started, request, logger),
      ),
      catchError((err) =>
        this.handleErrorResponse(err, started, request, logger),
      ),
    );
  }

  private getAdditionalHeaders(headers?: HttpHeaders): {
    [name: string]: string;
  } {
    const res: { [name: string]: string } = {};
    return res;
  }

  private performRequest(req: HttpRequest<any>): HttpRequest<any> {
    let headers: HttpHeaders = req.headers;

    // Prefijo de servidor unificado
    let url = req.url;
    const isExternalUrl = url.startsWith("https://");
    if (
      !isExternalUrl &&
      !url.startsWith("http://") &&
      !url.includes("assets") &&
      !url.includes("mock")
    ) {
      const config = this.configService.config;
      if (!config) {
        throw new Error("La configuración no ha sido cargada aún...");
      }

      const baseUrl = `${config.apiUrls.urlGatewayProcesos}proxy/afiliaciones`;
      url =
        baseUrl +
        (baseUrl.endsWith("/") && url.startsWith("/") ? url.substring(1) : url);
    }
    return req.clone({ url,
       setHeaders: this.getAdditionalHeaders(headers),
       withCredentials: true });
  }

  private handleSuccessfulResponse(
    event: any,
    started: number,
    req: HttpRequest<any>,
    logger: LoggerService,
  ): HttpResponse<any> {
    if (event instanceof HttpResponse) {
      const session = this.getSessionData();
      this.validatePaymentUrlInLogs(req)
      const id_afiliation = this.getAfiliationId(req,event);
      const id_novelty = this.validateNovelty(req)
      const support_profile = this.validateSupportProfile()
      const elapsed = Date.now() - started;
      logger.logInfo(
        `[HTTP ${req.method}] ${req.urlWithParams}`,
        "Ejecucion-Exitosa",
        {
          status: event.status,
          duration: `${elapsed} ms`,
          response: event.body,
          request: req,
        },
          support_profile,
          session.profiles,
          session.no_id,
          session.razon_social,
          session.transactionType,
          id_afiliation,
          id_novelty,
          session.id_employer
      );
      event = event.clone({ body: event.body.response });
    }
    return event;
  }

  private handleErrorResponse(
    errorResponse: any,
    started: number,
    req: HttpRequest<any>,
    logger: LoggerService,
  ): Observable<HttpEvent<any>> {
    const elapsed = Date.now() - started;
    if (
      errorResponse instanceof TimeoutError ||
      errorResponse.name === "TimeoutError"
    ) {
      const session = this.getSessionData();

      this.validatePaymentUrlInLogs(req)
      const id_afiliation = this.getAfiliationId(req);
      const id_novelty = this.validateNovelty(req)
      const support_profile = this.validateSupportProfile()
      logger.logError(`[HTTP ${req.method}] ${req.urlWithParams}`, {
        status: "Timeout",
        message: errorResponse.message,
        error: null,
        duration: `${elapsed} ms`,
        request: req,
      },
        support_profile,
        session.profiles,
        session.no_id,
        session.razon_social,
        session.transactionType,
        id_afiliation,
        id_novelty,
        session.id_employer
    );
      return throwError(() => "Timeout Exception");
    }

    if (errorResponse instanceof HttpErrorResponse) {
      const session = this.getSessionData();

      this.validatePaymentUrlInLogs(req)
      const id_afiliation = this.getAfiliationId(req);
      const id_novelty = this.validateNovelty(req)
      const support_profile = this.validateSupportProfile()
      logger.logError(`[HTTP ${req.method}] ${req.urlWithParams}`, {
        status: errorResponse.status,
        message: errorResponse.message,
        error: errorResponse.error,
        duration: `${elapsed} ms`,
        request: req,
      },
        support_profile,
        session.profiles,
        session.no_id,
        session.razon_social,
        session.transactionType,
        id_afiliation,
        id_novelty,
        session.id_employer
    );

      switch (errorResponse.status) {
        case 401:
          console.log("Sesión vencida, redirecciona al login");
          break;
        case 404:
          console.log("Recurso no encontrado");
          break;
        case 500:
        case 503:
          console.log("Error del servidor");
          break;
        default:
          console.log("Otro error HTTP");
      }
      return throwError(() => errorResponse);
    }
    return throwError(() => errorResponse);
  }

  private validatePaymentUrlInLogs(req: HttpRequest<any>) {
    const urlPayments = '/pagos/crear-transaccion';

    if (req.urlWithParams.includes(urlPayments)) {
      sessionStorage.setItem('transactionType', 'Compra de plan');
    } else {
      sessionStorage.setItem('transactionType', 'null');
    }
  }

private getAfiliationId(req: HttpRequest<any>,event?): string {
  const urlCreateAfiliation = '/registros/crear-afiliacion';
  const urlMassLoad = '/afiliacion/carga_masiva_v2';
  const profiles = sessionStorage.getItem('profiles') ?? '';
  const url = req.urlWithParams;

  if (url.includes(urlCreateAfiliation) && profiles !== '101') {
    return sessionStorage.getItem('id_afiliation') ?? 'null';
  }

  if (url.includes(urlMassLoad)) {
    const afiliations = JSON.stringify(event?.body?.objeto?.afiliaciones)
     sessionStorage.setItem('id_afiliation', afiliations);
     return
  }

  return 'null';
}

  private validateSupportProfile(){
     const profiles = sessionStorage.getItem('profiles') ?? '';
      const PRODUCT_SUPPORT_PRODUCT_PROFILE = '98'
            const COMERCIAL_PROFILE = '97'
            const supportProfile = profiles
              .split(',')
              .some(p =>
                [PRODUCT_SUPPORT_PRODUCT_PROFILE, COMERCIAL_PROFILE].includes(p)
              );
    if(supportProfile){
       return sessionStorage.getItem('idUser') ?? 'null'
    }
    return 'null'
  } 


  private validateNovelty(req: HttpRequest<any>){
    const urlNovelty = 'insertar-novedad-afiliaciones'
    if(req.urlWithParams.includes(urlNovelty)){
      return sessionStorage.getItem('id_novedad') ?? 'null'
    }
    return 'null'
  }


  private getSessionData() {
  return {
    id_contributor: sessionStorage.getItem('id_aportante') ?? 'null',
    id_employer: sessionStorage.getItem('id_empleador') ?? 'null',
    id_novedad: sessionStorage.getItem('id_novedad') ?? 'null',
    idSupportUser: sessionStorage.getItem('idUser') ?? 'null',
    razon_social: sessionStorage.getItem('razon_social') ?? 'null',
    no_id: sessionStorage.getItem('no_id') ?? 'null',
    profiles: sessionStorage.getItem('profiles') ?? 'null',
    transactionType: sessionStorage.getItem('transactionType') ?? 'null',
    id_afiliation: sessionStorage.getItem('id_afiliation') ?? 'null',
  };
}
}
